import mediaQuery from "@utils/mediaQuery";
import React, { ReactNode } from "react";
import styled from "styled-components";
import BackIcon from "@assets/icons/back-icon.svg";
import BackgroundCover from "@assets/images/background.svg";
import { useNavigate } from "react-router-dom";

interface Props {
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

const HeaderContainer = styled.div`
  position: relative;
  background-color: var(--bg-subpage);
  width: 100%;
  height: 437px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.div`
  max-width: 1320px;
  padding: 70px 16px;
  box-sizing: border-box;
  width: 100%;
  z-index: 1;

  ${mediaQuery("tablet")`
  padding: 0 100px;
  `}
`;

const Backbutton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-inverse);
  font-size: var(--font-size-xl);
  font-style: normal;
  font-weight: var(--font-weight-normal);
  line-height: var(--line-height-xl);
  margin-bottom: 24px;

  cursor: pointer;

  ${mediaQuery("tablet")`
    font-size: var(--font-size-2xl);
    line-height: var(--line-height-3xl);
`}

  span {
    display: flex;
  }
`;

const Title = styled.h1`
  color: var(--text-inverse);
  margin-bottom: 16px;

  ${mediaQuery("tablet")`
    font-size: var(--font-size-7xl);
    margin-bottom: 20px;
`}
`;

const Subtitle = styled.p`
  color: var(--text-inverse);
  font-size: var(--font-size-2xl);
  font-style: normal;
  font-weight: var(--font-weight-normal);
  line-height: var(--line-height-lg);

  ${mediaQuery("tablet")`
    font-size: var(--font-size-3xl);
    line-height: var(--line-height-2xl);
`}
`;

const TitleConatiner = styled.div`
  max-width: 475px;
`;

const BackgroundImageContainer = styled.div`
  svg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.3;

    symbol {
      path {
        fill: var(--color-navy-800);
      }
    }
  }
`;

const ContentWrapper = styled.div`
  background-color: var(--bg-app);
  display: flex;
  padding: 48px 16px;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;

  ${mediaQuery("tablet")`
  max-width: 1320px;
  display: flex;
  padding: 48px 100px 192px 100px;
  `}
`;

const SubpageLayout = ({ title, subtitle, children }: Props) => {
  const navigate = useNavigate();
  return (
    <>
      <HeaderContainer>
        <BackgroundImageContainer>
          <BackgroundCover />
        </BackgroundImageContainer>
        <Wrapper>
          <Backbutton onClick={() => navigate("/guidelines")}>
            <span>
              <BackIcon />
            </span>
            {/* */}
            Back to guidelines
          </Backbutton>
          <TitleConatiner>
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
          </TitleConatiner>
        </Wrapper>
      </HeaderContainer>
      <ContentWrapper>{children}</ContentWrapper>
    </>
  );
};

export default SubpageLayout;
